import { CopyToClipboardButton } from '@modules/common/components/CopyToClipboardButton';
import styles from './ListItem.module.scss';

interface ListItemProps {
    name: string;
    value: string | number | undefined;
}

const ListItem = ({ name, value }: ListItemProps) => (
    <div className={styles.item}>
        <div>{name}</div>
        <div>{value || '-'}</div>
        <CopyToClipboardButton textToCopy={value?.toString() || ''} />
    </div>
);

export default ListItem;
